import tw from "tailwind-styled-components";

export const BtnBtn2 = tw.button`
bg-teal-500 
hover:bg-teal-700 
text-white
 font-bold 
 py-1 
 px-3 
 rounded
  mr-2
  disabled:bg-gray-400
`;
